module.exports = __webpack_public_path__ + "img/Logo_iNoe_128px.a108b6ee.png";